// ELFINDER
$(document).on('click', '.popup_selector', function(event) {
    event.preventDefault();
    var updateID = $(this).attr('data-inputid'); // Btn id clicked
    var elfinderUrl = '/admin/utils/elfinder/input/';
    // trigger the reveal modal with elfinder inside
    var triggerUrl = elfinderUrl + updateID;
    $.colorbox({
        href: triggerUrl,
        fastIframe: true,
        iframe: true,
        width: '90%',
        height: '90%'
    });

});
// function to update the file selected by elfinder
function processSelectedFile(filePath, requestingField) {
    $('#' + requestingField).val(filePath).trigger('change');
}


// MAP
$(document).on('click', '.popup_location', function(event) {
    event.preventDefault();
    var requestingField = $(this).attr('data-inputid'); // Btn id clicked
    var choserUrl = '/admin/utils/map/input/' + requestingField + "/";
    var lat = $('#' + requestingField + "_lat").val();
    var lng = $('#' + requestingField + "_lng").val();
    // trigger the reveal modal with elfinder inside
    var triggerUrl = choserUrl + "?lat=" + lat + "&lng=" + lng;
    $.colorbox({
        href: triggerUrl,
        fastIframe: true,
        iframe: true,
        width: '90%',
        height: '90%'
    });
});
// function to update the location
function processSelectedLocation(lat, lng, requestingField) {
    console.log("processSelectedLocation", [lat, lng, requestingField]);
    var latitude = $('#' + requestingField + "_lat");
    if (latitude) {
        latitude.val(lat).trigger('change');
    }
    var longitude =  $('#' + requestingField + "_lng");
    if (longitude) {
        longitude.val(lng).trigger('change');
    }
    var location = $('#' + requestingField);
    if (location) {
        location.val(lat + ':' + lng).trigger('change');
    }
}
